import Forms from "../../../../app/Components/Forms/Forms";
import App from "../../../../app/App";
import Layout from "../../../../views/Layout/Layout";
import Clipboard from "../../../../app/Components/Clipboard/Clipboard";

const DssReport = {

    init() {

        this.el = $('[component="DssReport"]');

        if (!this.el.length) {
            return;
        }

        this.button = {
            ajax: $('[element="ajax"], .ajax')
        }
        this.hotlinks = this.el.find('[element="hotLinks"], [element="toolsMenu"]');

        this.start();
        this.bind();
    },

    start() {
        Promise.all(
            $(".nav, .company, .headerTitle").each(function (i, el) {
                $(this).children().addClass("ctc");
            })
        ).then(function () {
            Clipboard.create();
        });
    },

    bind() {
        this.button.ajax.on("click", async (element) => {

            clearTimeout(App.ajaxSendProtection);

            App.ajaxSendProtection = setTimeout(() => {

                let button = $(element.currentTarget).data();
                let cronJob = App.getCronJobLink(button.job);

                if (!cronJob) {
                    console.error("Missing cron link");
                    return false;
                }

                let data = {
                    link: CRON_ADRESS_SECURED,
                    request: cronJob
                };

                if (button.post) {
                    data.parameters = button.post;
                }

                App.showLoading();
                App.ajax(
                    button.library,
                    button.event,
                    data,
                    (response) => {
                        this.hotlinks.addClass("reportFound");
                        this.hotlinks.parents('[component="Alert"]').addClass("reportFound");

                        $('.storageLink').prop("href", response.storage_link);

                        if (response.download) {
                            let url = response.download.storage_link;

                            let filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
                            let xhr = new XMLHttpRequest();
                            xhr.responseType = 'blob';
                            xhr.onload = function () {
                                var a = document.createElement('a');
                                a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
                                a.download = filename; // Set the file name.
                                a.style.display = 'none';
                                document.body.appendChild(a);
                                a.click();
                            };
                            xhr.open('GET', url);
                            xhr.send();
                        }
                    }
                )

                Layout.hideModal(this.dialog);
            }, 500);

            return false;
        });
    },
}
export default DssReport;